<vip-pagamento-cupons
  class="vip-page-content"
  [cupons]="(cupons$ | async) || []"
  [cuponsSelecionados]="(cuponsSelecionados$ | async) || []"
  [codigoPromocional]="codigoPromocional$ | async"
  (changedSelecionados)="onChangeCuponsSelecionados($event)"
  (ativarCodigo)="validarCodigo($event)"
  (deleteCodigoPromocionalClick)="descontoFacade.removerCodigo($event)"
></vip-pagamento-cupons>
